export default __webpack_public_path__ + "static/media/official-1.7cb63ae6.png";